export const brandColors = {
  white: '#FFFFFF',
  black: '#000000',
  gray: '#D2D2D2',
  lightGray: '#CCCCCC',
  mediumGrey: '#adadad',
  grey: '#B3B0A8',
  darkGray: '#9e9e9e',
  offWhite: '#FFFBF0',
  heroYellow: '#FFF59B',
  heroYellow10: '#48452C',
  chargeYellow: '#FCE838',
  chargeRed: '#EE8C66',
  chargeBlue: '#A5C9FF',
  mediumBlue: '#49517D',
  heroBlue: '#181E3A',
  primaryMain: '#1F2647',
  primaryLight: '#EBD1D0',
  primaryDark: '#011F3A',
  secondaryMain: '#FFF6A1',
  secondaryLight: '#FFFDEA',
  secondaryDark: '#A39D63',
  errorMain: '#9E1E19',
  errorMainDark: '#FF8383',
  errorLight: '#EBD1D0',
  errorDark: '#661411',
  successMain: '#007505',
  successLight: '#CAE2CB',
  successDark: '#014B04',
  warningMain: '#E5C100',
  warningLight: '#FAF2C9',
  warningDark: '#957E01',
  infoMain: '#0065C1',
  infoLight: '#D2E4F4',
  infoDark: '#01407A',
  info90: '#EDF4FB',
  tintsChargeBlue20: '#4C5C74',
  tintsChargeBlue30: '#6A81A4',
  tintsChargeBlue50: '#A5C9FF',
  tintsChargeBlue60: '#C3DBFF',
  tintsChargeBlue70: '#DBE9FF',
  tintsChargeBlue80: '#EEF5FF',
  tintsChargeRed60: '#F3B197',
  tintsHeroBlue10: '#070911',
  tintsHeroBlue20: '#0C0E1B',
  tintsHeroBlue40: '#141930',
  tintsHeroBlue60: '#616578',
  tintsHeroBlue70: '#9FA1AD',
  tintsHeroBlue80: '#D4D5DA',
  tintsHeroBlue90: '#EFF0F2',
  tintsMediumBlue20: '#22263A',
  tintsMediumBlue60: '#878DAA',
  tintsMediumBlue80: '#DBDCE5',
  tintsMediumBlue90: '#F2F3F6',
  tintsNeutral10: '#474643',
  tintsNeutral20: '#6F6D68',
  tintsNeutral30: '#A3A09A',
  tintsOffWhite40: '#D0CCC3',
  tintsOffWhite50: '#F4F1EC',
  tintsOffWhite60: '#FFFCF5',
  tintsOffWhite80: '#FFFEFC',
  tintsOffWhite90: '#FFFFFE',
  textPrimary: '#171E39',
  semanticColorsError50: '#9E1E19',
  semanticColorsError60: '#BC6460',
  semanticColorsSuccess20: '#013803',
  semanticColorsSuccess90: '#EDF5ED',
  interactiveHeroBlueSubtle: '#1f26471a',
  foregroundInverseSubtle: '#ffffff1a',
};

export type BrandColors = keyof typeof brandColors;
